/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Configuration for a time slot within a day
*/
export class V3StackAdaptTimeSlot {
    /**
    * Start time of the time slot. Only start of hour times are recognized.
    */
    'startTime'?: string;
    /**
    * End time of the time slot. Must be greater than start time. Only end of hour times are recognized.
    */
    'endTime'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "string",
            "format": ""
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptTimeSlot.attributeTypeMap;
    }

    public constructor() {
    }
}

